import React from 'react';
import styles from '../../styles.module.scss';
import {Button, PriorityIcon, Title, Flex} from '@priority-software/priority-style-react';
import texts from '../../../../texts';
import {ReactComponent as WizardIcon} from '../../assets/wizardIcon.svg';

type Props = {
    content?: React.ReactNode;
    title?: string;
    onDismiss: () => void;
    onAccept: () => void;
    confirmButtonLabel?: string;
    style?: React.CSSProperties;
    showRemindLaterButton?: boolean;
};

export const ReminderWindow = (props: Props) => {
    const {
        content,
        title,
        onDismiss,
        onAccept,
        confirmButtonLabel,
        style,
        showRemindLaterButton = true
    } = props;

    return (
        <div className={styles.component} style={style}>
            {title && (
                <div className={styles.header}>
                    <WizardIcon width={27} height={27} />
                    <Title skin="h5">{title}</Title>
                </div>
            )}

            {content}

            <Flex
                componentClasses={styles.footer}
                justifyContent={showRemindLaterButton ? 'space-between' : 'flex-end'}
            >
                {showRemindLaterButton && (
                    <Button
                        prefixIcon={PriorityIcon.clock}
                        skin="text"
                        onClick={onDismiss}
                        componentClasses={styles.remindLaterBtn}
                    >
                        {texts.reminder_dismiss_label}
                    </Button>
                )}
                <Button skin="primary" size="small" onClick={onAccept}>
                    {confirmButtonLabel || texts.next_button_label}
                </Button>
            </Flex>
        </div>
    );
};
